import { api } from '../apiClient'
import type { Plumber, NearbyPlumberPreview } from '../../types'

export async function getNearbyPlumbers(postcode: string, radius?: number): Promise<Plumber[]> {
  const res = await api.get('/api/plumbers', { params: { postcode, radius } })
  return res.data
}

export async function getNearbyPlumberPreviews(postcode: string): Promise<NearbyPlumberPreview[]> {
  const res = await api.get<{ previews: NearbyPlumberPreview[] }>('/api/plumbers/nearby-previews', {
    params: { postcode },
  })
  return res.data.previews
}

export async function getPlumber(id: string): Promise<Plumber> {
  const res = await api.get(`/api/plumbers/${id}`)
  return res.data
}

export async function getPortalProfile(): Promise<Plumber> {
  const res = await api.get('/api/plumbers/portal/me')
  return res.data
}

export async function updatePortalProfile(data: {
  bio?: string
  specialties?: string[]
  responseRadiusKm?: number
  workingHours?: { alwaysOpen: boolean; schedule: Array<{ day: number; opensAt: string; closesAt: string }> }
}): Promise<Plumber> {
  const res = await api.put('/api/plumbers/portal/me', data)
  return res.data
}

export async function updateAvailability(status: 'available' | 'unavailable' | 'busy'): Promise<{ availabilityStatus: string }> {
  const res = await api.put('/api/plumbers/portal/me/availability', { status })
  return res.data
}

export async function initiateProfileClaim(plumberId: string): Promise<{ maskedPhone: string }> {
  const res = await api.post(`/api/plumbers/${plumberId}/claim`)
  return res.data
}

export async function verifyProfileClaim(plumberId: string, token: string): Promise<{ success: boolean; plumberId: string }> {
  const res = await api.post(`/api/plumbers/${plumberId}/verify-claim`, { token })
  return res.data
}
